import { render } from "./SimpleTable.vue?vue&type=template&id=5c1b3151&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=js"
export * from "./SimpleTable.vue?vue&type=script&lang=js"

import "./SimpleTable.vue?vue&type=style&index=0&id=5c1b3151&lang=scss&scoped=true"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1b3151"]])

export default __exports__